//베이스 URL
var domainCheck = location.hostname;
var tmpbaseUrl = "";
var chartUrl = "";
if(domainCheck != 'bid.emforce.co.kr') {
	tmpbaseUrl = 'http://beta.ad-api.emforce.co.kr';
	chartUrl = 'http://beta.stats.emforce.co.kr';
}else{
	tmpbaseUrl = 'http://ad-api.emforce.co.kr';
	chartUrl = 'http://stats.emforce.co.kr';
}//http://218.232.122.57:8090/api
const baseUrl = tmpbaseUrl;
export const dataUrl = {
	alwaysAPI:function(type, call, values) {
		var param = null;
		if(type == 'POST') {
			if(call == 'menuAdd') {
				param = baseUrl + '/bid_favorites/';
			}else if(call == 'login') {
				param = baseUrl + '/user_login/login/' + values;
			}
		}else if(type == 'GET') {
			if(call == 'news') {
				param = baseUrl + '/rept_job_history/execute_list/' + values;
			}else if(call == 'leftMenu') {
				param = baseUrl + '/adv/list/' + values;
			}else if(call == 'subMenu') {
				param = baseUrl + '/bid_favorites/count/?adv_id=' + values;
			}
		}else if(type == 'PUT') {
			if(call == 'news'){
				param = baseUrl + '/rept_job_history/read_dt/' + values;
			}else if(call == 'menuModify') {
				param = baseUrl + '/bid_favorites/';
			}else if(call == 'settingUpdate') {
				param = baseUrl + '/adv/upgrade/' + values;
			}
		}else if(type == 'DELETE') {
			if(call == 'menuDelete') {
				param = baseUrl + '/bid_favorites/';
			}
		}
		return param;
	},
	createAPI:function(type, call, values) {
		var param = null;
		if(type == 'POST') {
			if(call == 'add'){
				//데이터 기간 설정 생성
				param = baseUrl + '/rept_execute/';
			}else if(call == 'save') {
				//매일 예약 저장
				param = baseUrl + '/rept_execute/';
			}
		}else if(type == 'GET') {
			if(call == 'history') {
				//작업 목록 가져오기
				param = baseUrl + '/rept_job_history/' + values;
			}else if(call == 'status') {
				param = baseUrl + '/rept_job_history/status/?rept_job_history_id=' + values;
			}else if(call == 'saveCheck') {
				param = baseUrl + '/rept_execute/' + values;
			}
		}else if(type == 'PUT') {
			if(call == 'history') {
				//작업 목록 수정하기
				param = baseUrl + '/rept_job_history/?rept_job_history_ids=' + values;
			}
		}else if(type == 'DELETE') {
			if(call == 'daily') {
				param = baseUrl + '/rept_execute/?rept_execute_ids=' + values;
			}else if(call == 'history') {
				//작업 목록 수정하기
				param = baseUrl + '/rept_job_history/deleted_dt/?rept_job_history_ids=' + values;
			}
		}
		return param;
	},
	biddingAPI:function(type, call, values) {
		var param = null;
		if(type == 'POST') {
			if(call == 'bidUpdate') {
				param = baseUrl + '/integrate_rept/update_bid' + values;
			}
		}else if(type == 'GET') {
			if(call == 'historyDate') {
				param = baseUrl + '/rept_job_history/?adv_id=' + values;
			}else if(call == 'dateMatch') {
				param = baseUrl + "/integrate_rept/" + values;
			}else if(call == 'searchKeyword') {
				//키워드 검색 : 포함/정확/시작
				param = baseUrl + "/integrate_rept/" + values;
			}else if(call == 'addSelectField') {
				//고급 검색 - 유형 선택
				param = baseUrl + "/rept_fields/" + values;
			}else if(call == 'search') {
				//일반(고급) 검색
				param = baseUrl + "/integrate_rept/" + values;
			}else if(call == 'excel') {
				param = baseUrl + "/rept_excel/" + values;
			}else if(call == 'activeKeywordList' ){
				param = baseUrl + "/bid_favorites/list/?bid_status=Active&adv_id=" + values;
			}else if(call == 'NaverApiAmt'){
				param = baseUrl + "/naapi/view_bid/" + values;
			}else if(call == 'NaverApiCampaign'){
				param = baseUrl + "/naapi/campaign_list/?na_customer=" + values;
			}
		}else if(type == 'PUT') {


		}else if(type == 'DELETE') {

		}
		return param;
	},
	favoriteAPI:function(type, call, values) {
		var param = null;
		if(type == 'POST') {
			//키워드 추가 : 즐겨찾기 운영키워드 등록
			if(call == 'update_bid') {
				param = baseUrl + "/integrate_rept/update_bid/";
			}else if(call == 'keywordPush') {
				param = baseUrl + "/bid_favorites/";
			}else if(call == 'updateStatus') {
				param = baseUrl + "/integrate_rept/update_status/";
			}else if(call == 'naSync') {
				param = baseUrl + '/bid_favorites/na_sync/' + values;
			}
		}else if(type == 'GET') {
			if(call == 'search') {
				//즐겨찾기 키워드 검색 - 포함/일치/시작
				param = baseUrl + "/bid_favorites/list/" + values;
			}else if(call == 'masterSearch') {
				// 키워드 추가 : 즐겨찾기 운영키워드 검색 - 포함/정확/시작
				param = baseUrl +  "/bid_favorites/operated_kwd_list/" + values;
			}else if(call == 'keywordAddList-1') {
				param = baseUrl + "/naapi/campaign_list/" + values;
			}else if (call == 'keywordAddList-2') {
				param = baseUrl + "/naapi/group_list/" + values;
			}else if (call == 'keywordAddList-3') {
				param = baseUrl + "/naapi/kwd_sync/" + values;
			}else if(call == 'list') {
				//즐겨찾기 키워드 리스트
				param = baseUrl + "/bid_favorites/list/?adv_id=" + values;
			}else if(call == 'subList') {
				//즐겨찾기 키워드 서브 리스트
				param = baseUrl + "/bid_favorites/list/?bid_favorite_id=" + values;
			}else if(call == 'groupKey') {
				param = baseUrl + "/bid_favorites/inserted_kwd_list/" + values;
			}else if(call == 'keyStatus') {
				param = baseUrl + "/naapi/kwd_info/" + values;
			}else if(call == 'sort') {
				param = baseUrl + "/bid_favorites/list/" + values;
			}else if(call == 'history') {
				param = baseUrl + "/bid_file_history/read/" + values;
			}else if(call == 'schedule') {
				param = baseUrl + "/bid_favorites/bid_schedule/" + values;
			}else if(call == 'rate') {
				param = baseUrl + "/bid_favorites/bid_variations/" + values;
			}else if(call == 'chart') {
				param = chartUrl + "/stats/" + values;
 			}else if(call == 'chartExcel') {
 				param = chartUrl + "/stats/excel/" + values;
 			}
		}else if(type == 'PUT') {
			//순위/입찰가 작업 - 목표순위 변경 / 현재 입찰가 변경/ 입찰유형 변경/ 최대 입찰가 변경/ 목표순위,최대입찰가 일괄 변경 /
			if(call == 'update') {
				param = baseUrl + "/bid_favorites/";
			}else if(call == 'schedule') {
				param = baseUrl + "/bid_favorites/bid_schedule/";
			}else if(call == 'rate') {
				param = baseUrl + "/bid_favorites/bid_variations/";
			}
		}else if(type == 'DELETE') {
			if(call == 'update') {
				param = baseUrl + "/bid_favorites/";
			}
		}
		return param;
	},
	settingAPI:function(type, call, values) {
		var param = null;
		if(type == 'POST') {
			if(call == 'save') {
				param = baseUrl + "/rept_match_type/";
			}else if(call == "filter") {
				param = baseUrl + "/rept_config/?adv_id=" + values+ "&month_rept_config=0&week_rept_config=0&neo_duple_fields=이,것은,테스&neo_duple_sec=0";
			}
		}else if(type == 'GET') {
			if(call == 'client') {
				param = baseUrl + "/rept_match_type?adv_id="+values+"&status=True";
			}else if(call == 'naver') {
				param = baseUrl + "/rept_match_type/match/?adv_id="+values+"&status=True";
			}else if(call == 'neo') {
				param = baseUrl + "/rept_match_type/match/?adv_id="+values+"&status=True";
			}else if(call == 'filter') {
				param = baseUrl + "/rept_config/?adv_id=" + values;
			}
		}else if(type == 'PUT') {

		}else if(type == 'DELETE') {

		}
		return param;
	}
}



// WEBPACK FOOTER //
// ./js/controller/assets/dataUrl.js